import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue";
// Styles
import "./VBtnGroup.css";

// Composables
import { makeBorderProps, useBorder } from "../../composables/border.js";
import { makeComponentProps } from "../../composables/component.js";
import { provideDefaults } from "../../composables/defaults.js";
import { makeDensityProps, useDensity } from "../../composables/density.js";
import { makeElevationProps, useElevation } from "../../composables/elevation.js";
import { makeRoundedProps, useRounded } from "../../composables/rounded.js";
import { makeSizeProps } from "../../composables/size.js";
import { makeTagProps } from "../../composables/tag.js";
import { makeThemeProps, provideTheme } from "../../composables/theme.js";
import { makeVariantProps } from "../../composables/variant.js"; // Utilities
import { toRef } from 'vue';
import { genericComponent, propsFactory, useRender } from "../../util/index.js"; // Types
export const makeVBtnGroupProps = propsFactory({
  baseColor: String,
  connected: Boolean,
  divided: Boolean,
  direction: {
    type: String,
    default: 'horizontal'
  },
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeElevationProps(),
  ...makeRoundedProps(),
  ...makeSizeProps({
    size: undefined
  }),
  ...makeTagProps(),
  ...makeThemeProps(),
  ...makeVariantProps()
}, 'VBtnGroup');
export const VBtnGroup = genericComponent()({
  name: 'VBtnGroup',
  props: makeVBtnGroupProps(),
  setup(props, {
    slots
  }) {
    const {
      themeClasses
    } = provideTheme(props);
    const {
      densityClasses
    } = useDensity(props);
    const {
      borderClasses
    } = useBorder(props);
    const {
      elevationClasses
    } = useElevation(props);
    const {
      roundedClasses,
      roundedStyles
    } = useRounded(props);
    provideDefaults({
      VBtn: {
        height: toRef(() => props.direction === 'horizontal' && props.size == null ? 'auto' : null),
        baseColor: toRef(() => props.baseColor),
        color: toRef(() => props.color),
        density: toRef(() => props.density),
        flat: true,
        size: toRef(() => props.size),
        variant: toRef(() => props.variant)
      }
    });
    useRender(() => {
      return _createVNode(props.tag, {
        "class": _normalizeClass(['v-btn-group', `v-btn-group--${props.direction}`, {
          'v-btn-group--connected': props.connected,
          'v-btn-group--divided': props.divided,
          'v-btn-group--has-size': props.size != null
        }, `v-btn-group--size-${props.size ?? 'default'}`, themeClasses.value, borderClasses.value, densityClasses.value, elevationClasses.value, roundedClasses.value, props.class]),
        "style": _normalizeStyle([roundedStyles.value, props.style])
      }, slots);
    });
  }
});
//# sourceMappingURL=VBtnGroup.js.map